export function shouldIgnoreQuestionNavigationShortcut(
  event: KeyboardEvent,
): boolean {
  if (document.querySelector(".modal.show")) {
    return true;
  }

  const target = event.target as HTMLElement | null;
  if (!target) {
    return false;
  }

  return (
    target.tagName === "INPUT" ||
    target.tagName === "TEXTAREA" ||
    target.isContentEditable === true
  );
}
